import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import TOP20_SPOTS from '../data/top20SpotsData';
import './PageIndustriaAnio.css';
import './PageTop20Spots.css';

function PageTop20Spots() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="top20spots-page">
        <header className="top20spots-header">
          <button className="btn-back" onClick={() => navigate('/top-10-tv')}>
            &#8592; Top 10 TV
          </button>
          <div className="top20spots-title-block">
            <h1 className="top20spots-title">Top 20 Spots</h1>
            <p className="top20spots-subtitle">
              Spots m&aacute;s frecuentes &middot; Televisi&oacute;n Honduras 2025
            </p>
          </div>
          <button className="btn-next" onClick={() => navigate('/top-10-radio')}>
            Top 10 Radio &#8594;
          </button>
          <img
            src={require('../assets/logo-publisearch.png')}
            alt="Publisearch"
            className="header-logo-inline"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          />
        </header>

        <div className="top20spots-grid">
          {TOP20_SPOTS.map((spot) => (
            <a
              key={spot.idVersion}
              className="spot-card"
              href={spot.testigo}
              target="_blank"
              rel="noopener noreferrer"
              style={{ animationDelay: `${(spot.pos - 1) * 0.05}s` }}
            >
              <div className="spot-thumb-wrap">
                <img
                  src={spot.thumbnail}
                  alt={spot.nombre}
                  className="spot-thumb"
                  loading="lazy"
                />
                <div className="spot-play-overlay">
                  <svg viewBox="0 0 24 24" className="spot-play-icon">
                    <polygon points="5,3 19,12 5,21" />
                  </svg>
                </div>
                <span className="spot-pos">#{spot.pos}</span>
                <span className="spot-dur">{spot.duracion}s</span>
              </div>

              <div className="spot-info">
                <h3 className="spot-name">{spot.nombre}</h3>
                <p className="spot-brand">{spot.marca}</p>
                <div className="spot-stats-row">
                  <span className="spot-freq">{spot.veces.toLocaleString()} veces</span>
                </div>
                <div className="spot-channels">
                  {spot.canales.split(', ').map((ch) => (
                    <span key={ch} className="spot-channel-pill">{ch}</span>
                  ))}
                </div>
              </div>
            </a>
          ))}
        </div>

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageTop20Spots;
